'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../../node_modules/is-url/index.js');
var index_es = require('../../node_modules/slate/dist/index.es.js');

var withLinks = editor => {
  var {
    insertData,
    insertText,
    isInline
  } = editor;

  editor.isInline = element => {
    return element.type === 'link' ? true : isInline(element);
  };

  editor.insertText = text => {
    if (text && index(text)) {
      wrapLink(editor, text);
    } else {
      insertText(text);
    }
  };

  editor.insertData = data => {
    var text = data.getData('text/plain');

    if (text && index(text)) {
      wrapLink(editor, text);
    } else {
      insertData(data);
    }
  };

  return editor;
};
var insertLink = function insertLink(editor, url) {
  var selection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  console.log({
    url,
    selection
  });

  if (selection) {
    index_es.Transforms.select(editor, selection);
  }

  console.log(editor.selection);

  if (editor.selection) {
    wrapLink(editor, url);
  }
};
var isLinkActive = editor => {
  var [link] = index_es.Editor.nodes(editor, {
    match: n => !index_es.Editor.isEditor(n) && index_es.Element.isElement(n) && n.type === 'link'
  });
  return !!link;
};
var unwrapLink = editor => {
  index_es.Transforms.unwrapNodes(editor, {
    match: n => !index_es.Editor.isEditor(n) && index_es.Element.isElement(n) && n.type === 'link'
  });
};
var wrapLink = (editor, url) => {
  if (isLinkActive(editor)) {
    unwrapLink(editor);
  }

  var {
    selection
  } = editor;
  var isCollapsed = selection && index_es.Range.isCollapsed(selection);
  var link = {
    type: 'link',
    url,
    children: isCollapsed ? [{
      text: url
    }] : []
  };

  if (isCollapsed) {
    index_es.Transforms.insertNodes(editor, link);
  } else {
    index_es.Transforms.wrapNodes(editor, link, {
      split: true
    });
    index_es.Transforms.collapse(editor, {
      edge: 'end'
    });
  }
};

exports.insertLink = insertLink;
exports.isLinkActive = isLinkActive;
exports.unwrapLink = unwrapLink;
exports.withLinks = withLinks;
exports.wrapLink = wrapLink;
